import { styled } from '@mui/material/styles';

// const NAV_WIDTH = 280;
// const COLLAPSED_WIDTH = 66;
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const MainLayout = styled('div', {
    shouldForwardProp: (prop) => prop !== 'collapsed'
})(({ theme, collapsed }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(5),
    // marginLeft: collapsed ? COLLAPSED_WIDTH : NAV_WIDTH,
    transition: 'all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
    // willChange: 'padding-left',
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

export default MainLayout;
